export default {
    marking: "Маркировка",
    marking_action_cancel: "Отмена",
    marking_action_chz_result: "Результат Честного ЗНАКа",
    marking_action_date: "Дата выбытия",
    marking_action_income: "Приход",
    marking_action_income_cancel: "Отмена прихода",
    marking_action_manual_fix: "Ручное исправление",
    marking_action_movement: "Перемещение",
    marking_action_movement_cancel: "Отмена перемещения",
    marking_action_pending_scan: "Ожидает сканирования",
    marking_action_retry: "Повторная отправка",
    marking_action_scan: "Сканирование",
    marking_action_send: "Отправка в Честный ЗНАК",
    marking_action_sign: "Подписание",
    marking_action_visit_bind: "Привязка к визиту",
    marking_action_visit_unbind: "Отвязка от визита",
    marking_action_write_off: "Списание",
    marking_auth_hint: "Авторизация выполняется подписью УКЭП на этом компьютере через КриптоПро. Закрытый ключ не передаётся в Dentist Plus. Токен действует около 10 часов",
    marking_authorize: "Авторизоваться",
    marking_authorized: "Авторизация в Честном ЗНАКе выполнена",
    marking_bound_to_visit: "Привязан к визиту #{id}",
    marking_cancel_in_chz: "Отменить выбытие в Честном ЗНАКе (LK_RECEIPT_CANCEL)",
    marking_cancel_locally: "Отменить операцию",
    marking_check_connection: "Проверить подключение",
    marking_check_in_chz: "Проверить в Честном ЗНАКе",
    marking_choose_certificate: "Выберите сертификат",
    marking_chz_document_id: "ID документа в ЧЗ",
    marking_chz_not_required: "Не требуется",
    marking_chz_product: "Товар в Честном ЗНАКе",
    marking_chz_status: "Статус ЧЗ",
    marking_code: "Код маркировки (КИ)",
    marking_code_empty: "Пустой код",
    marking_code_history: "История кода",
    marking_code_no_serial: "В коде нет серийного номера",
    marking_code_not_datamatrix: "Это не код маркировки DataMatrix",
    marking_code_scanned_twice: "Этот код уже отсканирован",
    marking_code_wrong_gtin: "Неверный GTIN",
    marking_codes_progress: "Коды маркировки {scanned}/{amount}",
    marking_connected: "Подключено",
    marking_connection: "Подключение к Честному ЗНАКу",
    marking_connection_ok: "Подключение работает",
    marking_counter_accepted: "Принято",
    marking_counter_errors: "Ошибки",
    marking_counter_pending_scan: "Нужно сканировать",
    marking_counter_waiting: "Ожидают отправки",
    marking_create_material: "Создать материал",
    marking_crypto_invalid: "криптопроверка не пройдена",
    marking_cryptopro_instruction: "Инструкция по установке",
    marking_cryptopro_not_supported: "Браузер не поддерживает работу с КриптоПро.",
    marking_diag_auth_key: "Авторизация (запрос + подпись УКЭП)",
    marking_diag_cises_check: "Проверка криптохвоста",
    marking_diag_cises_info: "Сведения о КИ",
    marking_diag_code: "Код DataMatrix",
    marking_diag_document_create: "Создание документа",
    marking_diag_document_id: "ID документа",
    marking_diag_document_info: "Статус документа",
    marking_diag_gtin: "GTIN",
    marking_diag_product_info: "Товар по GTIN",
    marking_diag_sign_in: "Получение UUID-токена",
    marking_document_draft: "Не подписан",
    marking_documents_queued: "Подписано и поставлено в очередь документов: {count}",
    marking_emulation_on: "Режим эмуляции: Честный ЗНАК и подпись имитируются, ничего реально не отправляется",
    marking_enabled: "Работа с Честным ЗНАКом",
    marking_enabled_hint: "Если выключено, склад работает как раньше. Если включено, отдельные материалы можно отметить как маркируемые и указать GTIN",
    marking_env_production: "Промышленный контур",
    marking_env_sandbox: "Тестовый контур (sandbox)",
    marking_environment: "Контур",
    marking_errors: "Ошибок",
    marking_first_code_added: "Материал создан, код добавлен в приход",
    marking_gtin_hint: "14 цифр. Можно отсканировать DataMatrix с любой упаковки",
    marking_hide_codes: "Скрыть коды",
    marking_history: "История",
    marking_indicator_errors: "ошибок {count}",
    marking_indicator_hint: "Незавершённые операции маркировки",
    marking_indicator_scan: "сканировать {count}",
    marking_indicator_sign: "подписать {count}",
    marking_inn: "ИНН организации",
    marking_is_marked: "Маркируемый товар (Честный ЗНАК)",
    marking_link_material: "Связать «{name}» с этим GTIN и включить маркировку",
    marking_manual_fix: "Исправить",
    marking_no_certificates: "На компьютере не найден ни один сертификат для подписи",
    marking_not_connected: "Нет действующей авторизации",
    marking_nothing_pending: "Нет материалов, ожидающих сканирования",
    marking_nothing_to_sign: "Нет операций для отправки",
    marking_operation: "Операция",
    marking_organization: "Организация",
    marking_pending_explanation: "Количество уже списано в визитах. Отсканируйте коды использованных упаковок — повторного списания не будет",
    marking_pending_scan_count: "ожидает сканирования: {count}",
    marking_pending_scan_hint: "Сканируйте коды использованных упаковок подряд. Материал определяется по GTIN",
    marking_product_group: "Товарная группа",
    marking_product_group_medical: "Медицинские изделия",
    marking_production_not_allowed_hint: "Промышленный контур включается отдельно после успешного теста в sandbox",
    marking_progress_auth: "Авторизация в Честном ЗНАКе...",
    marking_progress_prepare: "Формирование документов...",
    marking_progress_sign: "Подписание документа {current} из {total}...",
    marking_reconnect: "Переподключить",
    marking_registered_at: "Оприходован",
    marking_require_visit_binding: "Требовать точную привязку КИ к визиту при сканировании в конце дня",
    marking_require_visit_binding_hint: "КИ — код идентификации, код DataMatrix на упаковке. Если материал списали в визите без сканирования, упаковка попадает в список «Ожидает сканирования», и её код можно отсканировать позже, например в конце дня. Если опция выключена, код сам привязывается к самому раннему неотсканированному списанию этого материала в любом визите. Если включена, перед сканированием нужно выбрать конкретный визит, и код попадёт именно в него",
    marking_retry: "Отправить повторно",
    marking_run: "Выполнить",
    marking_sandbox_warning: "Тестовый контур: сведения отправляются в sandbox Честного ЗНАКа",
    marking_scan: "Сканировать",
    marking_scan_all: "Сканировать всё",
    marking_scan_datamatrix: "Сканировать DataMatrix",
    marking_scan_income_hint: "Сканируйте каждую поступившую упаковку. Материал определяется по GTIN, неизвестный можно создать по данным Честного ЗНАКа",
    marking_scan_input_hint: "Поставьте курсор в поле и сканируйте упаковки подряд",
    marking_scan_movement_hint: "Сканируйте ровно те упаковки, которые перемещаются",
    marking_scan_placeholder: "Отсканируйте код DataMatrix",
    marking_scan_visit_hint: "Коды можно сканировать после сохранения визита с этим материалом",
    marking_scanned: "Отсканировано",
    marking_sent_at: "Отправлен",
    marking_setup_step_1: "Получите квалифицированную электронную подпись (КЭП). Руководитель получает её бесплатно в удостоверяющем центре ФНС. Если подписывать будет сотрудник, ему нужна своя КЭП и машиночитаемая доверенность (МЧД)",
    marking_setup_step_2: "Установите на компьютер, с которого будете подписывать: КриптоПро CSP, плагин «КриптоПро ЭЦП Browser plug-in» и драйвер токена (Рутокен, JaCarta)",
    marking_setup_step_3: "Зарегистрируйтесь в Честном ЗНАКе на сайте markirovka.crpt.ru с этой подписью (бесплатно). В профиле добавьте товарную группу «Медицинские изделия». Сотрудников, которые будут подписывать, добавьте пользователями",
    marking_setup_step_4: "Подключите ЭДО с поставщиками. Маркированный товар поставщик передаёт через ЭДО, и клинике нужно принять его там. Пока товар не принят, Честный ЗНАК не считает его вашим и не даст вывести его из оборота",
    marking_setup_step_5: "Здесь, в Dentist Plus: укажите ИНН, включите работу с Честным ЗНАКом, сохраните и нажмите «Авторизоваться», затем выберите сертификат",
    marking_setup_title: "Как подключить клинику к Честному ЗНАКу",
    marking_show_codes: "Показать коды",
    marking_sign_and_send: "Подписать и отправить",
    marking_sign_explanation: "Сведения о выбытии подписываются УКЭП владельца сертификата на этом компьютере и отправляются в Честный ЗНАК очередью. Если ЧЗ недоступен, отправка повторится автоматически",
    marking_sign_hint: "Все ожидающие операции будут собраны в документы LK_RECEIPT (по одному на дату) и подписаны выбранным сертификатом",
    marking_signed_by: "Подписал",
    marking_status_accepted: "Принято",
    marking_status_cancel_requested: "Ожидает отмены",
    marking_status_cancelled: "Отменено",
    marking_status_error: "Ошибка",
    marking_status_pending: "Ожидает отправки",
    marking_status_pending_scan: "Требует сканирования",
    marking_status_ready: "Ожидает подписи",
    marking_status_sending: "Отправлено, ждём результат",
    marking_step: "Шаг",
    marking_stock_in_stock: "На складе",
    marking_stock_incoming: "В непроведённом приходе",
    marking_stock_reserved: "Привязан к визиту",
    marking_stock_status: "Физический статус",
    marking_stock_transferred: "Перемещён",
    marking_stock_used: "Использован",
    marking_stock_written_off: "Списан",
    marking_tab_diagnostics: "Диагностика",
    marking_tab_documents: "Документы ЧЗ",
    marking_tab_overview: "Обзор",
    marking_tab_pending: "Требуют сканирования",
    marking_tab_registry: "Реестр КИ",
    marking_token_valid_till: "Токен действует до",
    marking_type_medical_use: "Вывод из оборота: медицинское применение",
    marking_type_receipt_cancel: "Отмена вывода из оборота",
    marking_units_to_scan: "Нужно отсканировать",
    marking_valid_till: "Действует до",
    marking_visit_binding_required_hint: "Включена точная привязка: укажите номер визита, к которому относятся сканируемые упаковки",
    marking_visit_number: "Номер визита",
    marking_waiting_since: "Ожидает с",
    marking_with_codes: "С КИ",
    marking_without_codes: "Без КИ",
}
